<template>
  <div>
    <Loading v-if="loading && days.length == 0" />
    <Error v-else-if="error != null" :message="error" />
    <NoTimes v-else-if="days.length == 0" />
    <div>
      <NextAvailable v-if="next_available != null" :s="next_available" @choose="choose" />
      <div v-bind:key="day.id" v-for="day in days">
        <div class="anchor" :id="day.id"></div>
        <div class="mt-3 clearfix">
          <!-- <div class="float-right"><LoadMore v-if="showLoadMore && day.label == 'Today'" @more="more" /></div> -->
          <h4 class="mb-2">{{ day.label }}</h4>
        </div>
        <NoTimes v-if="day.slots.length === 0" />
        <div v-else class="slots mx-n2">
          <DaySlots :slots="day.slots" @choose="choose" />
        </div>
      </div>
    </div>
    <div class="pt-3">
      <LoadMore v-if="showLoadMore" @more="more" />
    </div>
  </div>
</template>

<script charset="utf-8">
import NoTimes from "./NoTimes.vue";
import Loading from "./Loading.vue";
import Error from "./Error.vue";
import NextAvailable from "./NextAvailable.vue";
import DaySlots from "./DaySlots.vue";
import LoadMore from "./LoadMore.vue";
import moment from "moment";

const LoadMoreDays = 7;

export default {
  name: "TimeSlotsView",
  props: ["bus", "onChoose", "loadData"],
  components: {
    Loading,
    Error,
    NoTimes,
    NextAvailable,
    DaySlots,
    LoadMore,
  },

  data() {
    return {
      loading: true,
      next_available: null,
      error: null,
      showLoadMore: false,
      days: [],

      loadDate: moment(new Date()),
      loadDays: 7,
    };
  },

  methods: {
    more(moreDays) {
      this.loadDays = moreDays || LoadMoreDays;
      this.showLoadMore = false;

      $("#date-picker").show();
      return this.load(true);
    },

    reload() {
      this.loadDate = moment(new Date());
      this.loadDays = 7;
      this.load();
    },

    maxDate() {
      return moment().add(1, "month").endOf("day");
    },

    // Loads slots
    load(append) {
      var self = this;
      self.loading = true;

      var data = this.loadData ? this.loadData(this) : {};
      data.date = this.loadDate.format("DD/MM/YYYY");
      var daysLeft = this.maxDate().diff(self.loadDate, "d") + 1;
      data.days = Math.min(this.loadDays, daysLeft);
      const isAppointmentServiceNotAssigned = typeof appointmentService === "undefined";
      const isUsingServiceTypePriceDefined = typeof isUsingServiceTypePrice !== "undefined";

      if (!isAppointmentServiceNotAssigned) {
        data.provider_filter.service = appointmentService;
      }

      const { provider_filter } = data;

      if (isUsingServiceTypePriceDefined && isUsingServiceTypePrice && !provider_filter.service) {
        self.loading = false;
        if (noStaffServices) {
          self.error = "There are no services available for booking, please contact the organization."
        } else {
          self.error = "To see available times, please select a service type.";
        }
        return;
      }

      $("#loadingModal").modal({ show: true, backdrop: "static" });

      return new Promise(function (resolve, reject) {
        $.getJSON("/appointments/available_time_slots", data, function (response, status, xhr) {
          var success = false;
          if (status == "error") {
            var details = ": " + xhr.status + " " + xhr.statusText;
            if (xhr.status == 504) details = ".";
            self.error = "We are unable to display appointments due to a technical issue. Please contact us if this persists.<br/><small>Could not connect to the server" + details + "</small>";
          } else {
            if (response.success) {
              self.error = null;
              if (append) {
                self.days = self.days.concat(response.days);
              } else {
                self.days = response.days;
                self.next_available = response.next_available;
              }

              self.loadDate = self.loadDate.add(self.loadDays, "days");
              self.showLoadMore = Math.ceil(self.maxDate().diff(self.loadDate, "h") / 24.0) > 0;
              success = true;
            } else {
              self.error = "There was an error loading available slots";
            }
          }

          if (success) resolve();
          else reject();
        })
          .fail(function (xhr) {
            if (xhr.status == 500) {
              self.error = "There was an error fetching available appointment times. Please try again later.";
            }
            reject();
          })
          .always(function () {
            self.loading = false;
            $("#loadingModal").modal("hide");
          });
      });
    },

    // Chooses slot
    choose(slots) {
      slots = _.map(slots, function (s) {
        return {
          start_time: s.ts,
          end_time: s.te,
          staff_profile_id: s.sid,
          location_id: s.lid,
        };
      });

      this.onChoose(slots);
    },

    // Returns TRUE if the date is within the range of loaded.
    isLoaded(date) {
      var firstLoadedDate = moment();
      var lastLoadedDate = this.loadDate;
      var res = date.isBefore(lastLoadedDate, "day") && date.isSameOrAfter(firstLoadedDate, "day");
      return res;
    },

    // Loads slots until the given date. Returns the last loaded date.
    loadUntilDate(date) {
      var lastLoadedDate = this.loadDate;
      var days = Math.ceil(date.diff(lastLoadedDate, "days", true)) + 1;
      if (days > 0) {
        return this.more(days).then(function () {
          return date;
        });
      } else {
        return new Promise(function (resolve, reject) {
          reject("Can't load slots before today");
        });
      }
    },

    // Scroll the view to a given date. Loads if not loaded yet.
    scrollToDate(date) {
      if (!this.isLoaded(date)) {
        this.loadUntilDate(date).then(this.scrollToDate);
      } else {
        var anchor = date.format("#YYYY-MM-DD");
        if ($(anchor).length) {
          $("html, body").animate({ scrollTop: $(anchor).offset().top }, "slow", function () {
            location.href = anchor;
          });
        } else {
          alert("Sorry, there are no times available on that day.");
        }
      }
    },
  },

  mounted() {
    $(".date-picker").datetimepicker({
      inline: true,
      minDate: moment(),
      maxDate: this.maxDate(),
      useCurrent: false,
      buttons: { showToday: false },
      format: "L",
    });

    $(".date-picker").on("change.datetimepicker", (e) => {
      this.scrollToDate(moment(e.date));
    });

    this.bus.$emit("mounted", this);
  },
};
</script>
